export class VideoPlayer {
  #htmlElement;
  #overlay;
  #iframeContainer;
  #closeButton;

  constructor() {
    const videos = document.querySelectorAll('[data-video-id]');
    if (videos.length === 0) return;

    this.#htmlElement = document.documentElement;
    this.#overlay = document.getElementById('video-overlay');
    this.#iframeContainer = document.getElementById('video-iframe-container');
    this.#closeButton = document.getElementById('video-close-button');
    this.#bindEvents(videos);
  }

  #openVideoPlayer(videoID) {
    this.#htmlElement.classList.add('video-player-open');

    const iframeElement = document.createElement('iframe');
    iframeElement.width = '880';
    iframeElement.height = '495';
    iframeElement.src = `https://www.youtube-nocookie.com/embed/${videoID}?autoplay=1&rel=0`;
    iframeElement.title = 'YouTube video player';
    iframeElement.frameBorder = '0';
    iframeElement.setAttribute('allow',
      'accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;web-share');
    iframeElement.setAttribute('allowfullscreen', '');
    iframeElement.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    this.#iframeContainer.innerHTML = '';
    this.#iframeContainer.appendChild(iframeElement);
  }

  #closeVideoPlayer() {
    this.#htmlElement.classList.remove('video-player-open');
    if (this.#iframeContainer && this.#iframeContainer.firstChild)
      this.#iframeContainer.removeChild(this.#iframeContainer.firstChild);
  }

  #bindEvents(videos) {
    videos.forEach(el => {
      el.addEventListener('click', () => {
        const videoID = el.dataset.videoId;
        if (videoID) this.#openVideoPlayer(videoID);
      });
    });
    this.#overlay.addEventListener('click', e => {
      if (e.target === this.#overlay) this.#closeVideoPlayer();
    });
    this.#closeButton.addEventListener('click', () => {
      this.#closeVideoPlayer();
    });
  }
}
